<div class="content-option-picker">
  <i class="fa fa-lg fa-angle-left fa-icon-clickeable" [ngClass]="{ 'invisible': !this.datePicker.has_previous }" (click)="previousDate()"></i>
  {{ datePicker.values[datePicker.selected_index].date }}
  <i class="fa fa-lg fa-angle-right fa-icon-clickeable" [ngClass]="{ 'invisible': !this.datePicker.has_next }" (click)="nextDate()"></i>
</div>